export const INVITE_FORM = 'inviteCreativeForm';
export const MESSAGE_REQUIRED = 'Please enter a message.';



// WEBPACK FOOTER //
// ./invite/constants.js